import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  area: string;
  idsObraChecklistServicos: number[] | undefined;
};

type Actions = {};

export const useReeinspecaoObraAreaFilters = create<State & Actions>((set) => ({
  area: '',
  idsObraChecklistServicos: undefined,
}));

export const initialReeinspecaoObraAreaFilters: Partial<State> = {
  area: '',
};